import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { FormGroup } from '../../../../../Components/FormGroup/FormGroup';

function QuestionSet({ register, errors, id, isChecked, defaultOption }) {
  return (
    <div className="px-5 py-1">
      {id === isChecked && (
        <div className="row d-flex">
          <div className="col-lg-4 col-12">
            <div className="d-flex align-items-center">
              <label>
                <FormattedMessage id="question.work_experience" />
              </label>
              <StyledSelect>
                <FormGroup
                  id={`thematic_area[${id}][experience]`}
                  type="number"
                  register={register}
                  error={errors}
                  // error={{
                  //   [`thematic_area[${id}][experience]`]:
                  //     errors?.thematic_area &&
                  //     errors?.thematic_area[id] &&
                  //     errors?.thematic_area[id]?.experience
                  // }}
                  className="ms-3"
                  defaultValue={defaultOption.year}
                  required={true}
                  errorId={'thematic_area.work_experience'}
                />
              </StyledSelect>
            </div>
            {errors?.thematic_area?.[id]?.experience ? (
              <div className="text-danger text-center ">
                {errors?.thematic_area?.[id]?.experience?.message}
              </div>
            ) : null}
          </div>
          <div className="col-lg-4 col-12">
            <div className="d-flex align-items-center">
              <label>
                <FormattedMessage id="question.training_taken" />
              </label>
              <StyledSelect>
                <FormGroup
                  id={`thematic_area[${id}][training_taken]`}
                  type="number"
                  min={0}
                  register={register}
                  error={errors}
                  className="ms-3"
                  defaultValue={defaultOption.training_taken}
                  required={true}
                  errorId={'thematic_area.trainning_taken'}
                />
              </StyledSelect>
            </div>
            {errors?.thematic_area?.[id]?.training_taken ? (
              <div className="text-danger text-center ">
                {errors?.thematic_area?.[id]?.training_taken?.message}
              </div>
            ) : null}
          </div>

          <div className="col-lg-4 col-12">
            <div className="d-flex align-items-center">
              <label>
                <FormattedMessage id="question.training_given" />
              </label>
              <StyledSelect>
                <FormGroup
                  id={`thematic_area[${id}][training_given]`}
                  type="number"
                  min={0}
                  register={register}
                  error={errors}
                  className="ms-3"
                  defaultValue={defaultOption.training_given}
                  required={true}
                  errorId={'thematic_area.trainning_given'}
                />
              </StyledSelect>
            </div>
            {errors?.thematic_area?.[id]?.training_given ? (
              <div className="text-danger text-center ">
                {errors?.thematic_area?.[id]?.training_given?.message}
              </div>
            ) : null}
          </div>
        </div>
      )}
    </div>
  );
}

export default QuestionSet;

const StyledSelect = styled.div`
  width: 60px;
`;
